import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import initialState from "../initial-state";

const spinnerOverlay = createSlice({
  name: "spinnerOverlay",
  initialState: initialState.spinnerOverlay,
  reducers: {
    showSpinnerOverlay(
      state,
      action: PayloadAction<{ style?: any; size?: number; stroke?: number }>
    ) {
      const style = action.payload.style ?? {};
      const size = action.payload.size ?? -1;
      const stroke = action.payload.stroke ?? -1;

      return { ...state, visible: true, style, size, stroke };
    },
    hideSpinnerOverlay(state) {
      return { ...state, visible: false };
    },
  },
});

export const { showSpinnerOverlay, hideSpinnerOverlay } =
  spinnerOverlay.actions;

export default spinnerOverlay;
